import { isNumber } from "lodash"

export enum ApplicationFeature {
  SpeakUp = "speakup",
  Lea = "lea",
  Led = "led",
  Pimeo = "pimeo",
  Users = "users",
  Settings = "settings",
}

export enum ApplicationPath {
  Base = "/",

  Login = "/login",
  Error = "/error",

  ChangePasswordRequest = "/user/password/requestchange",
  ChangePassword = "/user/password/change",

  ApplicationHub = "/apphub",
  SpeakUpPackageNotActivated = `/${ApplicationFeature.SpeakUp}`,
  SpeakUpScheduledSurveys = `/${ApplicationFeature.SpeakUp}/scheduled-surveys/:surveyId(\\d+)?/:action(new|edit)?`,
  SpeakUpDashboard = `/${ApplicationFeature.SpeakUp}/dashboard`,
  SpeakUpSurveys = `/${ApplicationFeature.SpeakUp}/surveys/:surveyId(\\d+)?/:action(new)?`,
  SpeakUpQuestions = `/${ApplicationFeature.SpeakUp}/questions`,

  Lea = `/${ApplicationFeature.Lea}`,
  LeaScheduledSurveys = `/${ApplicationFeature.Lea}/scheduled-surveys/:surveyId(\\d+)?/:action(new|edit)?`,
  LeaDashboard = `/${ApplicationFeature.Lea}/dashboard`,
  LeaSurveys = `/${ApplicationFeature.Lea}/surveys/:surveyId(\\d+)?/:action(new)?`,

  LedDashboard = `/${ApplicationFeature.Led}/dashboard`,
  LedDiscussions = `/${ApplicationFeature.Led}/discussions`,
  LedStatistics = `/${ApplicationFeature.Led}/statistics`,

  PimeoStatistics = `/${ApplicationFeature.Pimeo}/statistics`,

  Users = `/${ApplicationFeature.Users}`,
  Recipients = `/${ApplicationFeature.Users}/recipients`,
  Permissions = `/${ApplicationFeature.Users}/administrators`,
  Groups = `/${ApplicationFeature.Users}/groups`,

  Settings = `/${ApplicationFeature.Settings}`,
}

export abstract class APPLICATION_URL {
  static base() {
    return "/"
  }

  static workspaceHome(workspaceName: string) {
    // eslint-disable-next-line max-len
    return `${window.location.protocol}//${workspaceName}.${process.env.REACT_APP_APPLICATION_HOSTNAME}${window.location.port && ":" + window.location.port}`
  }

  static login() {
    return ApplicationPath.Login
  }

  static error() {
    return ApplicationPath.Error
  }

  static changePasswordRequest() {
    return ApplicationPath.ChangePasswordRequest
  }

  static changePassword() {
    return ApplicationPath.ChangePassword
  }

  static appHub() {
    return ApplicationPath.ApplicationHub
  }

  static speakupScheduledSurveys() {
    return `/${ApplicationFeature.SpeakUp}/scheduled-surveys/`
  }

  static leaScheduledSurveys() {
    return "/lea/scheduled-surveys/"
  }

  static speakupSurveys(target?: number | "new") {
    let path = `/${ApplicationFeature.SpeakUp}/surveys/`

    if (isNumber(target)) {
      path += target
    }

    if (target === "new") {
      path += "new"
    }

    return path
  }

  static leaSurveys(target?: number | "new") {
    let path = "/lea/surveys/"

    if (isNumber(target)) {
      path += target
    }

    if (target === "new") {
      path += "new"
    }

    return path
  }

  static speakupQuestions() {
    return ApplicationPath.SpeakUpQuestions
  }

  static speakupPackageNotActivated() {
    return ApplicationPath.SpeakUpPackageNotActivated
  }

  static speakupDashboard() {
    return ApplicationPath.SpeakUpDashboard
  }

  static ledStatistics() {
    return ApplicationPath.LedStatistics
  }

  static speakupScheduledSurvey(id: number, section?: string, commentId?: number | string) {
    let target = APPLICATION_URL.speakupScheduledSurveys() + id

    if (section) {
      target += `?section=${section}`
    }

    if (commentId) {
      target += `&comment=${commentId}`
    }

    return target
  }

  static leaScheduledSurvey(id: number, section?: string, commentId?: number | string) {
    let target = APPLICATION_URL.leaScheduledSurveys() + id

    if (section) {
      target += `?section=${section}`
    }

    if (commentId) {
      target += `&comment=${commentId}`
    }

    return target
  }

  static editSpeakUpScheduledSurvey(id: number) {
    return APPLICATION_URL.speakupScheduledSurveys() + `${id}/edit`
  }

  static editLeaScheduledSurvey(id: number) {
    return APPLICATION_URL.leaScheduledSurveys() + `${id}/edit`
  }

  static newSpeakupScheduledSurvey() {
    return APPLICATION_URL.speakupScheduledSurveys() + "new"
  }

  static newLeaScheduledSurvey() {
    return APPLICATION_URL.leaScheduledSurveys() + "new"
  }

  static editSurvey(id: number) {
    return this.speakupSurveys(id)
  }

  static newSurvey() {
    return this.speakupSurveys("new")
  }

  static recipients() {
    return ApplicationPath.Recipients
  }

  static permissions() {
    return ApplicationPath.Permissions
  }

  static groups() {
    return ApplicationPath.Groups
  }

  static settings() {
    return ApplicationPath.Settings
  }

  static lea() {
    return ApplicationPath.Lea
  }

  static pimeoStatistics() {
    return ApplicationPath.PimeoStatistics
  }
}
